import {Component, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {SiteModel} from '../../../models/site.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../../services/new-document.service';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';
import {TestConnectionService} from '../../../services/test-connection.service';
import {RefreshdatabaseService} from '../../../services/database/refreshdatabase.service';
import {GeneralService} from '../../../services/general.service';
import {RefreshLiveDetailLinesService} from '../../../services/refresh-live-detail-lines.service';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../../definitions/barcode-options';
import {PersistScannedBarcodesService} from '../../../services/persist-scanned-barcodes.service';
import {EquipmentInfoModalComponent} from '../equipment-info-modal/equipment-info-modal.component';
import {ScanBarcodeService} from '../../../services/scan-barcode.service';

@Component({
    selector: 'app-check-ward',
    templateUrl: './check-ward-health-care.component.html',
    styleUrls: ['./check-ward-health-care.component.scss'],
})
export class CheckWardHealthCareComponent implements OnInit {
    documentTemp: DocumentModel;
    loading: any;
    manualInput: string;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private generalService: GeneralService,
                private loadingController: LoadingController,
                private refreshLiveDetailLinesService: RefreshLiveDetailLinesService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService,
                private scanBarcodeService: ScanBarcodeService) {
    }

    async ngOnInit() {
        this.documentTemp = this.newDocumentService.genNewDocument();
        await this.refreshLiveDetailLinesService.refreshLiveDetailLines();
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.site = new SiteModel();
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    cancelCheck() {
        this.modalController.dismiss();
    }

    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // const modal = await this.modalController.create({
        //     component: ScanBarcodeCheckWardComponent,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         document: this.documentTemp
        //     }
        // });
        // modal.onDidDismiss().then(() => {
        // });
        // return await modal.present();
    }

    async handleScanResult(event) {
        console.log('Scan Result');
        console.log(event);
        this.manualInput = null;
        let equipment = this.scanBarcodeService.findLiveLineByBarcode(event) as DetaillineDTOModel;
        if (equipment) {
            this.persistScannedBarcodesService.persistBarcode(event);
            equipment = JSON.parse(JSON.stringify(equipment));
            await this.handleEquipmentFoundWithBarcode(equipment);
        } else {
            this.generalService.createToast('No match with barcode: ' + event);
        }
    }

    async handleEquipmentFoundWithBarcode(equipment: any) {
        const modal = await this.modalController.create({
            component: EquipmentInfoModalComponent,
            backdropDismiss: false,
            cssClass: 'auto-height',
            componentProps: {
                document: this.documentTemp,
                equipment: equipment
            }
        });
        modal.onDidDismiss().then(() => {
        });
        return await modal.present();
    }
}
